import angular from "angular";

angular
    .module('app')
    .component('recaptchaForm', {
        template: require('./recaptcha-form.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.result = null;

    $ctrl.success = function () {
        $ctrl.close();
    };
}
